import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentsImportAPIService as DocImportService } from 'wflow-main-app/src/app/core/api/api/documents/documents-import.service';
import { ImportService } from '../../components/import-file-dialog/import-file-dialog.interface';

@Injectable({
  providedIn: 'root',
})
export class DocumentsImportService implements ImportService {
  public readonly templateUrl = '/assets/files/example-documents-import.xlsx';

  constructor(private documentsImportService: DocImportService) {}

  import(format: string, file: File): Observable<any> {
    return this.documentsImportService.importDocument(format, file);
  }
}
